import { Wallet } from '../../types/wallet'
import { Exchange } from '../../types/exchange'

export function calculateAverageRating({
  features_rating,
  onboarding_rating,
  support_rating,
  usability_rating,
}: {
  features_rating: string
  onboarding_rating: string
  support_rating: string
  usability_rating: string
}): number {
  return (
    (parseFloat(features_rating || '0') +
      parseFloat(onboarding_rating || '0') +
      parseFloat(support_rating || '0') +
      parseFloat(usability_rating || '0')) /
    4
  )
}

// This orders the wallets/exchanges first by campaign and then by score.
// It adds 10 to not interfere with the campaigns
export function calculatePosition(obj: Wallet | Exchange): number {
  const averageRating = calculateAverageRating(obj)
  const campaignPosition = obj.campaign?.position
  const normalPosition = Math.abs(averageRating - 5) + 10
  return campaignPosition || normalPosition
}
